import { render, staticRenderFns } from "./moduleAdmin.vue?vue&type=template&id=a49d4d4a&"
import script from "./moduleAdmin.vue?vue&type=script&lang=js&"
export * from "./moduleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./moduleAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports